import { defineComponent as r, openBlock as n, createBlock as a, unref as m, mergeProps as p, withCtx as i, createElementVNode as l } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const d = /* @__PURE__ */ r({
  name: "IconMoreHorizontal",
  __name: "IconMoreHorizontal",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (s, e) => (n(), a(m(c), p(t, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        l("path", { d: "M19 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4m-7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4m-9-2a2 2 0 1 0 4 0 2 2 0 0 0-4 0" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
